import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { ConformComponent } from '../../conform/conform.component';
import { PatientService } from '../../shared';

@Component({
  selector: 'app-welcomemail',
  templateUrl: './welcomemail.component.html',
  styleUrls: ['../style.component.css', './welcomemail.component.css']
})
export class WelcomemailComponent implements OnInit {
  notmatched: boolean = false;
  dobvalid: boolean;
  patid: any;
  maxdate: boolean;
  mindate: boolean;
  showinvaild1: boolean;

  showinvaild: boolean = false
  patname: any = '';
  public timealert = environment.timelimit;
  public dateformat = environment.dateFormat;
  dateform: any;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  public user: any = {
    dob: '',
  }
  public bobMaxDate = new Date();
  welcome: any;
  modalRef: any;
  public datenew = new Date("01/01/1800");
  resdata: any;
  expires: MatDialogRef<ConformComponent>;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private nav: Router,
    private dialog: MatDialog,
    private localeService: BsLocaleService

  ) {
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
  }

  ngOnInit() {


    this.routerr.params.subscribe(params => {
      this.patid = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      ////////console.log(this.patid);
    });


    this.patientservice
      .getwelcomepat(this.patid)
      .subscribe(
        data => {
          if (data.status == 'failure') {
            this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
            this.expires.componentInstance.message = data.message;
          }
          else {
            this.patname = data.patientName;
            if (data.dateFormat == 'DDMMYYYY') {
              this.dateformat = 'DD/MM/YYYY'
              this.dateform = 'dd/MM/yyyy'
            } else {
              this.dateformat = 'MM/DD/YYYY'
              this.dateform = environment.dateFormat
            }
            this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
            // ////console.log("name",this.patname)
          }
        },
        err => {
          this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
        }
      );

  }


  checkinvaild(id) {
    // ////console.log("id",id)
    if (id == "Invalid Date") {
      this.showinvaild = true;


    } else {
      this.showinvaild = false
    }
  }
  saveUser(userForm: NgForm, result) {
    //////console.log("result",result.value);

    this.user.dob = this.datepipe.transform(this.user.dob, 'yyyy-MM-dd');
    // ////console.log("dob",this.user.dob)
    this.patientservice
      .getwelcome(this.patid, this.user.dob)
      .subscribe(
        data => {

          //////console.log(data);
          window.localStorage['randId'] = this.patid
          if (data.userInfo.status == "success") {
            this.nav.navigate(['uservalidate']);
          }
          else if (data.userInfo.status == "failure") {

            this.notmatched = true
            userForm.reset();
          }
          else {
            this.resdata = "Unauthorized Access";
            this.modalRef = this.modalService.show(result, { class: 'modal-sm', backdrop: "static" });

          }
        }
      );

  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
    if (event.target.value.length == 10) {
      this.dobvalid = true
    } else {
      this.dobvalid = false
    }
  }

  checkempty1(id) {
    //this.notmatched = false;
    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild1 = true;
      this.mindate = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date <= "1800-01-01") {
      this.mindate = true;
      this.showinvaild1 = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;
      this.mindate = false;
    } else {
      this.showinvaild1 = false;
      this.mindate = false;
      this.maxdate = false;
    }

  }

}
